import moment, { Moment } from 'moment-timezone';
import { getCurrentFiscalYearFromLocal } from './reportingScope';

/** METRO fiscal year: Oct 1 (calendar FY-1) through Sep 30 (calendar FY). */
const MAX_DAILY_RANGE_DAYS = 90;

function utcDateOnlyFromYmd(ymd: string): Date {
    const parsed = moment.utc(ymd, 'YYYY-MM-DD', true);
    return new Date(Date.UTC(parsed.year(), parsed.month(), parsed.date()));
}

function formatUtcDateFromMs(ms: number): string {
    return new Date(ms).toISOString().slice(0, 10);
}

export function getFiscalYearDailyRange(
    fiscalYear: number,
    timeZoneName: string,
    now?: Moment,
): { dailyFrom: string; dailyTo: string } {
    const fyStartMs = Date.UTC(fiscalYear - 1, 9, 1);
    const fyEndMs = Date.UTC(fiscalYear, 8, 30);

    const local = (now ?? moment()).tz(timeZoneName || 'UTC');
    const todayLocalYmd = local.format('YYYY-MM-DD');
    const todayMs = utcDateOnlyFromYmd(todayLocalYmd).getTime();

    let rangeEndMs = Math.min(fyEndMs, todayMs);

    if (rangeEndMs < fyStartMs) {
        rangeEndMs = fyStartMs;
    }

    let rangeStartMs = rangeEndMs;
    rangeStartMs -= (MAX_DAILY_RANGE_DAYS - 1) * 24 * 60 * 60 * 1000;
    if (rangeStartMs < fyStartMs) {
        rangeStartMs = fyStartMs;
    }

    return {
        dailyFrom: formatUtcDateFromMs(rangeStartMs),
        dailyTo: formatUtcDateFromMs(rangeEndMs),
    };
}

export function isCurrentFiscalYear(fiscalYear: number, timeZoneName: string, now?: Moment): boolean {
    const local = (now ?? moment()).tz(timeZoneName || 'UTC');
    return fiscalYear === getCurrentFiscalYearFromLocal(local);
}
